import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useSalonBrand } from '../brand/useSalonBrand'
import { marketFor, normHex } from '../email-composer/email/theme'
import { salonLinks } from '../email-composer/email/links'
import { familyForLook } from '../social/render/families'
import { townOf } from '../social/data/captions'
import { previewLinks } from './data/preview'

// Everything Bailey's plans and the campaign builder need to know about the
// salon: its trade, name, brand look, town, country and links. The same on
// Marketing › Home and the Campaigns tab.
export const useMarketingKit = () => {
  const user = useSelector(s => s.user)
  const brand = useSalonBrand()
  const salon = brand.salon
  const hairdresser = (user && user.userInfo && user.userInfo.hairdresser) || {}
  const userSalon = hairdresser.salon
  const trade = marketFor(salon && salon.businessType) || marketFor(userSalon && userSalon.businessType) || 'hair'
  const salonName = brand.spec.name || (salon && salon.salonName) || (userSalon && userSalon.salonName) || ''
  const brandColour = normHex(brand.spec.accent) || null
  const family = familyForLook(brand.spec.look)
  const town = townOf(salon && salon.formattedAddress)
  const country = String((userSalon && (userSalon.countryShortName || userSalon.country)) || (salon && (salon.countryShortName || salon.country)) || 'GB').toUpperCase().slice(0, 2)
  const kit = useMemo(() => ({ name: salonName || 'Your salon', accent: brandColour, logo: brand.spec.logo || null, display: brand.spec.display || null, text: brand.spec.text || null }), [salonName, brandColour, brand.spec.logo, brand.spec.display, brand.spec.text])
  const ctx = useMemo(() => ({ market: trade, kit: brand.spec, links: salonLinks(hairdresser), salonName }), [trade, brand.spec, salonName]) // eslint-disable-line react-hooks/exhaustive-deps
  const currency = hairdresser.currencySymbol || '£'
  // The salon's real links: sends use the gift voucher and shop pages;
  // previews show the booking page too
  const links = ctx.links
  const shown = useMemo(() => previewLinks(hairdresser), [hairdresser.salon && (hairdresser.salon.slug || hairdresser.salon._id)]) // eslint-disable-line react-hooks/exhaustive-deps
  return { user, brand, salon, hairdresser, trade, salonName, brandColour, family, town, country, kit, ctx, currency, links, previewLinks: shown }
}
